export const PageTitleStyles = {
    title: "text-[24px] leading-[32px] font-bold",
}